import React, { useState } from 'react';
import MainContent from '../layout/MainContent';
import PersonTypeList from './personTypes/PersonTypeList';
import { ICON_NEW } from '../extras/icons';
import PersonTypeForm from './personTypes/PersonTypeForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addPersonTypesAction } from '../../actions/personTypesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const PersonTypes = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addPersonTypesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Persona Tipos' 
                subtitle='Personas' 
                nodes={nodes}
                actions={actions}
                component={PersonTypeList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <PersonTypeForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default PersonTypes;